import { Task } from '@repo/shared';
import { useParams } from '@tanstack/react-router';

import DescribeImage from '@/routes/(app)/(tasks)/describe-image';
import ExtractStructure from '@/routes/(app)/(tasks)/extract-structure';
import TextTranslation from '@/routes/(app)/(tasks)/text-translation';

import GenerateAudio from './generate-audio';

const TaskDetails = () => {
  const { task } = useParams({
    from: '/app/tasks/$task',
  });

  if (task === Task.TEXT_TRANSLATION) {
    return <TextTranslation />;
  }

  if (task === Task.EXTRACT_STRUCTURE) {
    return <ExtractStructure />;
  }

  if (task === Task.GENERATE_AUDIO) {
    return <GenerateAudio />;
  }

  return <DescribeImage />;
};

export default TaskDetails;
